/*
 * Copyright (c) 2019. Nedaware SL
 */

import {Caster} from './caster';

/**
 * Adds € to financial type
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */
export class FinancialCaster implements Caster<number, string> {
    constructor(private fractionDigits: number = 2) {
    }

    fromModel(modelValue: number | null): string | null {
        if (modelValue !== null) {
            return `${modelValue.toFixed(this.fractionDigits)} €`;
        } else {
            return null;
        }
    }

    toModel(apiValue: string | null): number | null {
        if (apiValue === null) {
            return null;
        }
        if (apiValue.endsWith(' €')) {
            return parseFloat(apiValue.substring(0, -2));
        } else if (apiValue.endsWith('€')) {
            return parseFloat(apiValue.substring(0, -1));
        } else {
            return parseFloat(apiValue);
        }
    }
}
